import { inputFileToImage } from "./change-file-listener"

export const resetFileInput = (fileInput,imgEl, trashEl) => {
    if(fileInput) {
        fileInput.value = ''
        fileInput.setAttribute('value','')
    }
    if(imgEl) {
        imgEl.src = ''
        imgEl.classList.add('d-none')
    }
    trashEl?.classList.add('d-none')
    // resetFileInput
    const figCaption = fileInput.parentElement.parentElement.querySelector('.figcaption-value')
    figCaption.innerHTML = ''
} 

export const fileSelectorFunctionality = (fileSelectors) => {
  Array.from(fileSelectors).forEach((el) => {
      const fileInput = el.parentElement?.querySelector('input')
        el.addEventListener('drop', (ev) => {
            ev.preventDefault()
            if (ev.dataTransfer?.files?.length !== 0) {
                fileInput.files = ev.dataTransfer.files;
                inputFileToImage(fileInput.files, fileInput);
            }
        })
        el.addEventListener('dragover', (ev) => {
            ev.preventDefault()
        })
        el.addEventListener('keydown', (e) => {
            if (e.keyCode === 13) {
              el.click();
            }
        })
        el.addEventListener('click', (el) => {
          if(el.target.classList.contains('trash')) {
            el.target.classList.add('d-none')
            const imgEl =  el.target.parentElement?.querySelector('.file-selectors img')
            resetFileInput(fileInput, imgEl)
          } else {
            fileInput?.click();
          }
      })
  })
}